import { PINIA_PERSIST_OPTIONS } from "@/helpers/constants";
import { defineStore } from "pinia";

export interface TokenState {
  token?: string | null;
  refreshToken?: string | null;
}

export const useTokenStore = defineStore("token", {
  state: (): TokenState => ({
    token: null,
    refreshToken: null,
  }),
  actions: {
    setToken(token: string) {
      this.token = token;
    },
    setRefreshToken(refreshToken: string) {
      this.refreshToken = refreshToken;
    },
  },
  persist: PINIA_PERSIST_OPTIONS,
});
